<template>
  <v-container>
    <v-row justify="space-around" dense>
      <v-col>
        <v-menu
          v-model="menuStart"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="computedStartFormatted"
              label="Dalla data"
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="filtro.start = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filtro.start"
            no-title
            scrollable
            @input="menuStart = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col>
        <v-menu
          v-model="menuEnd"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="computedEndFormatted"
              label="Alla data"
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="filtro.end = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filtro.end"
            no-title
            scrollable
            @input="menuEnd = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col>
        <v-switch
          v-model="filtro.soloNonFatturate"
          class="mt-1"
          inset
          label="Solo non fatturate"
          @change="onFiltra"
        ></v-switch>
      </v-col>
      <v-col cols="1"><v-btn @click.stop="onFiltra">Ricerca</v-btn></v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable */
import _ from "lodash";
import configurazioni from "@/services/configurazioniService.js";

export default {
  data: (vm) => ({
    startFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    endFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    filtro: {
      start: null, // (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      end: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      soloNonFatturate: true,
    },
    menuStart: false,
    menuEnd: false,
    modal: false,
    loading: false,
  }),
  async mounted() {
    this.$emit("ricerca", this.filtro);
  },
  computed: {
    computedStartFormatted() {
      return this.formatDate(this.filtro.start);
    },
    computedEndFormatted() {
      return this.formatDate(this.filtro.end);
    },
  },
  watch: {
    "filtro.start"(val) {
      this.startFormatted = this.formatDate(this.filtro.start);
    },
    "filtro.end"(val) {
      this.endFormatted = this.formatDate(this.filtro.end);
    },
  },
  methods: {
    onFiltra() {
      this.$emit("ricerca", this.filtro);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async getValues(source, filtroCampo, filtroValore) {
      let elementi = [];
      let elementiFull = [];
      if (typeof source === "string") {
        const config = source.split(".");
        const configId = config[0];
        const subId = config[1] || ""; // TODO verificare
        const sub2 = config[2] || "";
        const sourceArray = await configurazioni.getConfigurazione(
          configId,
          subId
        );
        if (sub2) {
          elementiFull = sourceArray
            ? sourceArray.filter((x) => x.tipo === sub2)
            : [];
        } else {
          elementiFull = sourceArray ? sourceArray : [];
        }
        if (filtroCampo && filtroValore) {
          elementiFull = elementiFull.filter(
            (x) => _.get(x, filtroCampo, "") === filtroValore
          );
        }
        elementi = elementiFull.map((x) => {
          return { codice: x.codice, descrizione: x.descrizione };
        });
      } else if (Array.isArray(source)) {
        elementi = [...source];
      }
      return elementi;
    },
  },
};
</script>
